// extracted by mini-css-extract-plugin
export var externalLink = "_98-0";
export var internalLinkLabel = "_98-1";